<template>
  <basic-card padding hideHeader :hasMore="showMore">
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      v-model:search="search"
      v-model:page="page"
      :permission="permissionObj"
      :before-open="beforeOpen"
      v-model="form"
      ref="crud"
      @row-update="rowUpdate"
      @row-save="rowSave"
      @row-del="rowDel"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
      @on-load="onLoad"
    >
      <template #search-menu>
        <!-- 不用avue带的，自定义搜索、增删查改、批量操作。 -->
        <div class="search-menu-box">
          <div class="global-flex-center">
            <comp-button
              type="info"
              icon="icon-search"
              @click.stop="handleSearch()"
              >{{ Lang.btn.search }}
            </comp-button>
            <comp-button
              type="text"
              @click.stop="handleEmpty()"
              >{{ Lang.btn.empty }}
            </comp-button>
          </div>
          <div class="global-flex-center">
            <comp-button
              type="primary"
              icon="icon-add"
              v-if="permissionObj.add" 
              @click.stop="handleAdd()"
              >{{ Lang.btn.addNew }}
            </comp-button>
            
            <comp-button
              type="normal"
              @click="toggleShowMore()"
              >{{ Lang.btn.more }}
            </comp-button>
          </div>
        </div>
      </template>
      <template #header>
        <div class="search-menu-box-others" v-if="showMore">
          <comp-button
            type="delete"
            v-if="permissionObj.delete" 
            plain
            @click="handleDelete"
            >{{ Lang.btn.delete }}
          </comp-button>
        </div>
      </template>
      <!-- 操作菜单按钮 -->
      <template #menu="scope">
        <div class="operation-btns">
          <CompIconButton :auth="permissionObj" type="view" @click="handleView(scope.row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="edit" @click="handleEdit(scope.row)" > </CompIconButton>
          <CompIconButton :auth="permissionObj" type="delete" :divider="false" @click="handleDel(scope.row)" > </CompIconButton>
        </div>
      </template>

    </avue-crud>
  </basic-card>
</template>

<script>
import { getList, getDetail, add, update, remove } from '@/api/system/post';
import { mapGetters } from 'vuex';
import website from '@/config/website';
import { filterDollarKeys } from '@/utils/util';
export default {
  data() {
    return {
      tableKey: 0,
      form: {},
      query: {},
      loading: true,
      showMore: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        // height: 'auto',
        maxHeight: 600, // 因为设计要求分页不要固定在底部 height: 'auto'
        calcHeight: 84,
        tip: false,
        searchShow: true,
        searchSpan: 4,
        searchMenuSpan: 12,
        searchMenuPosition: 'auto',
        searchGutter: 20,
        gutter: 12,
        border: false,
        index: true,
        indexLabel: this.Lang.table.serialNumber,
        indexWidth: '100%',
        viewBtn: true,
        selection: true,
        menuWidth: 116, // 操作列宽
        emptyBtn: false,
        searchBtn: false,
        addBtn: false, // 添加
        viewBtn: false, // 查看
        editBtn: false, // 编辑
        delBtn: false, // 删除
        menuType: 'button',
        menuTitle: this.Lang.label.operation,
        menuHeaderAlign: 'right', // 操作按钮样式
        dialogClickModal: false,
        dialogType: 'drawer', // dialog drawer
        dialogCustomClass: 'dialog-custom-class-sort',
        searchLabelWidth: 'auto',
        searchLabelPosition: 'left',
        labelWidth: 'auto',
        labelPosition: 'top',
        searchLabelSuffix: ' ',
        column: [
          {
            label: this.$t('theader.tenants'),
            prop: 'tenantId',
            type: 'tree',
            dicUrl: '/blade-system/tenant/select',
            addDisplay: false,
            editDisplay: false,
            viewDisplay: website.tenantMode,
            span: 24,
            props: {
              label: 'tenantName',
              value: 'tenantId',
            },
            hide: !website.tenantMode,
            rules: [
              {
                required: true,
                message: this.Lang.tips.inputTenantBelongTo,
                trigger: 'click',
              },
            ],
          },
          {
            label: this.$t('theader.potitionType'),
            prop: 'category',
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=post_category',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
            dataType: 'number',
            slot: true,
            search: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelectPositionType,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.positionNo'),
            prop: 'postCode',
            search: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputPositionNum,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.potitionTitle'),
            prop: 'postName',
            search: true,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputPositionName,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.$t('theader.potitionSorting'),
            prop: 'sort',
            maxlength: 5,
            type: 'number',
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInputPositionSort,
                trigger: 'blur',
              },
            ],
          },
          {
            label: this.Lang.label.positionDesc,
            prop: 'remark',
            type: 'textarea',
            span: 24,
            minRows: 6,
            hide: true,
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['menuItem', 'permission']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      return obj
    },
    ids() {
      let ids = [];
      this.selectionList.forEach(ele => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    // 自定义查看
    handleView(row) {
      this.$refs.crud.rowView(row);
    },
    // 自定义编辑
    handleEdit(row) {
      this.$refs.crud.rowEdit(row);
    },
    // 自定义删除
    handleDel(row) {
      this.$refs.crud.rowDel(row);
    },
    // 自定义展开更多
    toggleShowMore() {
      this.showMore = !this.showMore;
      this.option.selection = this.showMore;
      this.tableKey += 1;
    },
    // 自定义搜索
    handleSearch() {
      console.log(this.search)
      const params = filterDollarKeys(this.search)
      this.onLoad(this.page, params)
    },
    // 自定义清空
    handleEmpty() {
      this.$refs.crud.searchReset();
    },
    // 自定义添加
    handleAdd() {
      this.$refs.crud.rowAdd();
    },
    rowSave(row, done, loading) {
      add(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      update(row).then(
        () => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          done();
        },
        error => {
          window.console.log(error);
          loading();
        }
      );
    },
    rowDel(row) {
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(row.id);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning(this.Lang.tips.plzSelectOne);
        return;
      }
      this.$confirm(this.Lang.tips.ifConfirmDelete, {
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        type: 'warning',
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail(this.form.id).then(res => {
          this.form = res.data.data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad(this.page);
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad(page, params = {}) {
      this.loading = true;
      getList(page.currentPage, page.pageSize, Object.assign(params, this.query)).then(res => {
        const data = res.data.data;
        this.page.total = data.total;
        this.data = data.records;
        this.loading = false;
        this.selectionClear();
      });
    },
  },
};
</script>

<style></style>
